import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Checkbox, FormControlLabel } from '@material-ui/core';
import assignIn from 'lodash/assignIn';
import { useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useClickAway, useDebounce } from 'react-use';
import { LinkAttributeValue } from 'types/content/Link';
import { AttributeContainer, AttributesContainer, CheckboxLabel, ConfirmButton, ConfirmIcon, Container, InputContainer, URLInput } from './ExternalLinkInput.style';
var URL_PREFIX = 'https://';
var VALID_URL_PREFIX_REGEX = /^https?:\/\//;
var VALID_URL_REGEX = /^(https?:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/;
var DEFAULT_EXTERNAL_LINK_DATA = {
  url: '',
  attributes: {
    target: LinkAttributeValue.TargetBlank,
    rel: LinkAttributeValue.RelNoFollow
  }
};

var ExternalLinkInput = function ExternalLinkInput(_ref) {
  var _data$attributes, _data$attributes2;

  var onClickAway = _ref.onClickAway,
      onConfirm = _ref.onConfirm,
      _ref$focusOnMount = _ref.focusOnMount,
      focusOnMount = _ref$focusOnMount === void 0 ? false : _ref$focusOnMount,
      initialData = _ref.initialData;
  var intl = useIntl();
  var containerRef = useRef(null);
  useClickAway(containerRef, function () {
    return onClickAway === null || onClickAway === void 0 ? void 0 : onClickAway();
  });
  var inputRef = useRef(null);
  useEffect(function () {
    if (focusOnMount) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [focusOnMount, inputRef]);

  var _useState = useState(function () {
    return assignIn(DEFAULT_EXTERNAL_LINK_DATA, initialData);
  }),
      data = _useState[0],
      setData = _useState[1];

  var _useState2 = useState(((_data$attributes = data.attributes) === null || _data$attributes === void 0 ? void 0 : _data$attributes.rel) === LinkAttributeValue.RelNoFollow),
      isNoFollow = _useState2[0],
      setIsNoFollow = _useState2[1];

  var _useState3 = useState(((_data$attributes2 = data.attributes) === null || _data$attributes2 === void 0 ? void 0 : _data$attributes2.target) === LinkAttributeValue.TargetBlank),
      isTargetBlank = _useState3[0],
      setIsTargetBlank = _useState3[1];

  var isURLInvalid = useMemo(function () {
    var matches = VALID_URL_REGEX.exec(data.url);
    return matches === null || matches.length === 0;
  }, [data]);
  useEffect(function () {
    setData(function (currentData) {
      return _objectSpread(_objectSpread({}, currentData), {}, {
        attributes: _objectSpread(_objectSpread({}, currentData.attributes), {}, {
          rel: isNoFollow ? LinkAttributeValue.RelNoFollow : undefined,
          target: isTargetBlank ? LinkAttributeValue.TargetBlank : undefined
        })
      });
    });
  }, [isNoFollow, isTargetBlank]);
  useDebounce(function () {
    if (data.url && VALID_URL_PREFIX_REGEX.exec(data.url) === null && URL_PREFIX.startsWith(data.url) === false) {
      setData(_objectSpread(_objectSpread({}, data), {}, {
        url: URL_PREFIX.concat(data.url)
      }));
    }
  }, 1000, [data.url]);
  return __jsx(Container, {
    ref: containerRef,
    "data-testid": "external-link-input"
  }, __jsx(InputContainer, null, __jsx(URLInput, {
    ref: inputRef,
    type: "text",
    value: data.url,
    placeholder: intl.formatMessage({
      id: 'link.external.placeholder'
    }),
    onChange: function onChange(event) {
      return setData(_objectSpread(_objectSpread({}, data), {}, {
        url: event.target.value
      }));
    }
  }), __jsx(ConfirmButton, {
    onClick: function onClick() {
      return onConfirm(data);
    },
    type: "button",
    disabled: isURLInvalid
  }, __jsx(ConfirmIcon, {
    disabled: isURLInvalid
  }))), __jsx(AttributesContainer, null, __jsx(AttributeContainer, null, __jsx(FormCheckbox, {
    checked: isNoFollow,
    labelId: "link.nofollow",
    onCheckboxClicked: function onCheckboxClicked() {
      return setIsNoFollow(function (value) {
        return !value;
      });
    }
  })), __jsx(AttributeContainer, null, __jsx(FormCheckbox, {
    checked: isTargetBlank,
    labelId: "link.target-blank",
    onCheckboxClicked: function onCheckboxClicked() {
      return setIsTargetBlank(function (value) {
        return !value;
      });
    }
  }))));
};

var FormCheckbox = function FormCheckbox(_ref2) {
  var checked = _ref2.checked,
      labelId = _ref2.labelId,
      onCheckboxClicked = _ref2.onCheckboxClicked;
  return __jsx(FormControlLabel, {
    control: __jsx(Checkbox, {
      color: "default",
      disableRipple: true,
      checked: checked,
      onClick: onCheckboxClicked
    }),
    label: __jsx(FormattedMessage, {
      id: labelId,
      tagName: CheckboxLabel
    })
  });
};

export default ExternalLinkInput;